import * as requestServices from "../request";

export const req = {
    getAllLocations(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {                
                 return res;
            })
        },   

    setAllLocations(url, data) {        
      return requestServices.post(url, data)
      .then((data) => (data))
      .then((res) => {
        return res;
      });
    },

    deleteLocation(url, branchId) {
      return requestServices
          .put(url + "/" + branchId)
          .then(data => data)
          .then(res => {
              return res;
          });
  },

}

